import React, { useEffect } from 'react';
import { useStateAsync } from './UseStateAsync';

/**
 * A wrapper hook to use localStorage as the backing for the value
 */
export function useLocalStorage(key: string, defaultValue?: string): [string | null, (value: string | null | ((prevState: string | null) => string | null)) => void, () => Promise<string | null>] {
  const [potato, setInternal, getInternalAsync] = useStateAsync<string | null>('');

  // Get current state from localStorage and use defaultValue if one is set
  useEffect(() => {
    let value = localStorage.getItem(key);

    // Check if we need to set the value
    if (value == null && defaultValue != null) {
      value = defaultValue;
    }

    setPotato(value);
  }, []);

  // Check localStorage ever 500ms for updates
  useEffect(() => {
    const id = setInterval( async () => {
      const value = localStorage.getItem(key);
      const currentInternal = await getInternalAsync();

      if (value !== currentInternal) {
        setPotato(value);
      }
    }, 500);

    return () => clearInterval(id);
  }, []);

  const setPotato = (value: string | null | ((prevState: string | null) => string | null)) => {
    setInternal(prevState => {
      let newState = typeof value === 'function' ? value(prevState) : value;

      // Add/Update or Remove, if null of course
      if (newState == null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, newState);
      }

      return newState;
    });
  };

  // Gets the current state from localStorage RIGHT NOW
  const getPotatoAsync = () => {
    return new Promise<string | null>((resolve) => {
      resolve(localStorage.getItem(key));
    });
  };

  return [potato, setPotato, getPotatoAsync];
}
